import script from "./SharedMe.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedMe.vue?vue&type=script&setup=true&lang=js"

import "./SharedMe.vue?vue&type=style&index=0&id=7c336d9f&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c336d9f"]])

export default __exports__